export default "__VITE_PUBLIC_ASSET__6c987ee3__"